export default "__VITE_ASSET__m4Md66yn__"